import { FC } from 'react';
import { ButtonPrimary } from '../../../../components/Button/ButtonPrimary';
import style from '../create-order.module.scss';

interface OrderSuccessProps {
  /** Backend-generated order ID for URL */
  orderId: number;
  /** The "number_of_order" that the user entered */
  orderNumber: string;
  /** Callback to reset "orderCreated" state in parent */
  onNewOrder: () => void;
}

const OrderSuccess: FC<OrderSuccessProps> = ({
  orderId,
  orderNumber,
  onNewOrder
}) => {
  console.log('OrderSuccess rendered with:', {
    orderId,
    orderNumber
  });
  return (
    <div className={style.orderCreatedContainer}>
      <p>
        Čestitamo! Porudžbina broj{' '}
        <span className="fw-bold">{orderNumber}</span> je uspešno kreirana.
      </p>
      <p>
        Možete je proveriti{' '}
        <a
          href={`/admin/orders/${orderId}`}
          target="_blank"
          rel="noopener noreferrer"
          className="cs-primary-color"
        >
          ovde
        </a>
        .
      </p>
      <ButtonPrimary onClick={onNewOrder}>Nova porudžbina</ButtonPrimary>
    </div>
  );
};

export default OrderSuccess;
